import { injectable, inject } from '@patsnap/tahiti-core/shared/inversify';
import { Emitter } from '@patsnap/tahiti-core/common/event';
import { AITranslationModel } from '../model/ai-translation.model';
import type { AITranslationState } from '../type/ai-translation.type';
import { AITranslationService } from '@/services/ai-translation/service/ai-translation.service';
import { AddTranslationAsyncTaskDTO, GetTranslationAsyncStatusDTO } from './ai-translation.repository.interface';

export const TranslationGeneratorAsyncService = Symbol('TranslationGeneratorAsyncService');

export interface TranslationGeneratorAsyncService {
    initialize: () => void;
    executeRegenerate: () => void;
}

@injectable()
export class TranslationGeneratorAsyncServiceImpl implements TranslationGeneratorAsyncService {
    private _onStatusChangeEmitter = new Emitter<any>();
    readonly onStatusChange = this._onStatusChangeEmitter.event;
    private _onContentChangeEmitter = new Emitter<any>();
    readonly onContentChange = this._onContentChangeEmitter.event;


    private _onStatesChangeEmitter = new Emitter<AITranslationState>();
    readonly onStatesChange = this._onStatesChangeEmitter.event;

    constructor(
        @inject(AITranslationModel)
        private _aiTranslationModel: AITranslationModel,
        @inject(AITranslationService)
        private _aiTranslationService: AITranslationService,
        @inject(AddTranslationAsyncTaskDTO)
        private _addTranslationAsyncTaskDTO: AddTranslationAsyncTaskDTO,
        @inject(GetTranslationAsyncStatusDTO)
        private _getTranslationAsyncStatusDTO: GetTranslationAsyncStatusDTO,
    ) {

        this._aiTranslationModel.onStatesChange(this._emitModelDataChange.bind(this));
    }


    private _emitModelDataChange() {
        this._onStatesChangeEmitter.fire(this.getAITranslationModelData());
    }


    public getAITranslationModelData() {
        return this._aiTranslationModel.modelData;
    }

    private _getTaskId() {
        return this._aiTranslationModel.modelData.taskId;
    }

    public initialize() {
        const params = {
            taskId: this._getTaskId(),
            currentStep: 'GENERATE',
        }

        this._addTranslationAsyncTaskDTO.fetch(params);
    }

    public async executeRegenerate() {
        const { content } = await this._getTranslationAsyncStatusDTO.fetch(this._getTaskId());

        if (content) {
            this._aiTranslationService.updateResult(content);
            this._aiTranslationService.handleGoResult();
            this._aiTranslationService.updateDrawerStatus(true);
        }

    }
}